
const Buttons = ({onClickHandeler, value, title}) => {
    return ( 
        <>
        <button onClick={onClickHandeler} value={value} className="btn">{title}</button>
        </>
     );
}
 
export default Buttons;